import { render, staticRenderFns } from "./NextButton.vue?vue&type=template&id=2a4c0f7a&scoped=true"
import script from "./NextButton.vue?vue&type=script&lang=js"
export * from "./NextButton.vue?vue&type=script&lang=js"
import style0 from "./NextButton.vue?vue&type=style&index=0&id=2a4c0f7a&prod&lang=scss&scoped=true"
import style1 from "./NextButton.vue?vue&type=style&index=1&id=2a4c0f7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4c0f7a",
  null
  
)

export default component.exports